import React, { useState, useEffect } from 'react';
import { Button } from '@chapche/ui';

const COOKIES_ACCEPTANCE_KEY = 'cookiesAreAccepted';
const COOKIES_ACCEPTANCE_VALUE = 'true';

export default function CookiesNotification() {
    const [cookiesAreAccepted, setCookiesAreAccepted] = useState(true);
    useEffect(() => {
        const cookieSavedResult = localStorage.getItem(COOKIES_ACCEPTANCE_KEY);
        if (!cookieSavedResult || cookieSavedResult !== COOKIES_ACCEPTANCE_VALUE) {
            setCookiesAreAccepted(false);
        }
    }, []);
    const handleCookiesAccept = () => {
        localStorage.setItem(COOKIES_ACCEPTANCE_KEY, COOKIES_ACCEPTANCE_VALUE);
        setCookiesAreAccepted(true);
    };
    if (cookiesAreAccepted) {
        return null;
    }
    return (
        <div className="notification-cookie fixed right-0 bottom-0 z-[1002] flex w-full flex-wrap items-center justify-center gap-20 bg-light-beige px-20 py-20">
            <p className="notification-cookie__text block__content m-0 max-w-[640px]">
                Мы используем файлы cookies, чтобы сделать сайт удобным для вас. Продолжая использование сайта, вы соглашаетесь с этим.
            </p>
            <Button
                type="button"
                className="notification-cookie__button w-[300px] justify-center"
                onClick={() => handleCookiesAccept()}
            >
                хорошо
            </Button>
        </div>
    );
}
